import {EntityWithMetadata} from '#common/models/Entity';
import {User} from '#common/users/types';

export const UserCacheKeyPrefix = 'quickstart:user:';

export function clearCachedUser(userId?: string): void {
  try {
    if (userId) {
      globalThis.localStorage?.removeItem(`${UserCacheKeyPrefix}${userId}`);
    }
  } catch {
    // Ignore storage errors in restricted environments
  }
}

export function getCachedUser(userId?: string): EntityWithMetadata<User> | undefined {
  if (!userId) {
    return undefined;
  }
  try {
    const raw = globalThis.localStorage?.getItem(`${UserCacheKeyPrefix}${userId}`);
    if (!raw) {
      return undefined;
    }
    return JSON.parse(raw) as EntityWithMetadata<User>;
  } catch {
    return undefined;
  }
}

export function setCachedUser(userId: string, user: EntityWithMetadata<User>): void {
  try {
    globalThis.localStorage?.setItem(`${UserCacheKeyPrefix}${userId}`, JSON.stringify(user));
  } catch {
    // Ignore storage quota errors
  }
}
